// extracted by mini-css-extract-plugin
export default {"tf":"tf__nQT3v","tf__wrap":"tf__wrap__eIA1T","tf__type":"tf__type__mrnS_","tf__type__value":"tf__type__value__qudwA","tf__popup":"tf__popup__OuZTW"};